module.exports = __webpack_public_path__ + "img/img_about02.92c72732.jpg";